var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.274 17.7037L10.4055 11.8519C9.92877 12.2469 9.36164 12.5597 8.70411 12.7901C8.04658 13.0206 7.34794 13.1358 6.60822 13.1358C4.75068 13.1358 3.18493 12.4938 1.91096 11.2099C0.636987 9.92593 0 8.3786 0 6.5679C0 4.7572 0.641096 3.20988 1.92329 1.92593C3.20548 0.641976 4.75068 0 6.5589 0C8.38356 0 9.92877 0.641976 11.1945 1.92593C12.4603 3.20988 13.0932 4.7572 13.0932 6.5679C13.0932 7.29218 12.9863 7.97531 12.7726 8.61728C12.5589 9.25926 12.2384 9.86831 11.811 10.4444L17.7041 16.2963C17.9014 16.4938 18 16.7284 18 17C18 17.2716 17.8932 17.5062 17.6795 17.7037C17.4822 17.9012 17.2438 18 16.9644 18C16.6849 18 16.4548 17.9012 16.274 17.7037ZM6.58356 11.1605C7.84932 11.1605 8.92603 10.7119 9.8137 9.81481C10.7014 8.9177 11.1452 7.83539 11.1452 6.5679C11.1452 5.30041 10.7014 4.21811 9.8137 3.32099C8.92603 2.42387 7.84932 1.97531 6.58356 1.97531C5.28493 1.97531 4.18767 2.42387 3.29178 3.32099C2.39589 4.21811 1.94795 5.30041 1.94795 6.5679C1.94795 7.83539 2.39589 8.9177 3.29178 9.81481C4.18767 10.7119 5.28493 11.1605 6.58356 11.1605Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.c921203f25499f501548e5a9d62431a6.svg";
export { ForwardRef as ReactComponent };